import { useMemo } from "react";
import {
	calculateProductsComparisonDiscount,
	defaultProductsComparison,
	getNextDistinctPrice,
	isEligibleVendorForDiscount,
} from "~/features/price-comparison/price-comparison-discounts";
import type { ProductDetailsSelectVendorItem } from "~/features/products/product-details-vendor-select.component";

export function useVendorSelectionPriceComparison({
	vendorOptions,
}: {
	vendorOptions: ProductDetailsSelectVendorItem[];
}) {
	const sameTypeVendors = useMemo(() => {
		return vendorOptions
			.filter(isEligibleVendorForDiscount)
			.sort((a, b) => a.price - b.price);
	}, [vendorOptions]);

	const getPriceComparisonDiscount = (
		sourceVendor: ProductDetailsSelectVendorItem | undefined,
	) => {
		const cheapestVendor = sameTypeVendors.at(0);
		if (
			!sourceVendor ||
			!isEligibleVendorForDiscount(sourceVendor) ||
			!cheapestVendor ||
			sourceVendor.price !== cheapestVendor.price
		) {
			return defaultProductsComparison;
		}
		const comparisonPrice = getNextDistinctPrice(sameTypeVendors);
		return calculateProductsComparisonDiscount(
			{
				price: cheapestVendor.price,
			},
			comparisonPrice === undefined
				? undefined
				: {
						price: comparisonPrice,
					},
		);
	};

	return { getPriceComparisonDiscount };
}
